
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

interface GoalsStepProps {
  formData: {
    primaryGoals: string[];
    secondaryGoals: string[];
    timeframe: string;
    additionalNotes: string;
  };
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSelectChange: (name: string, value: string) => void;
  handleCheckboxChange: (list: string, value: string) => void;
}

export function GoalsStep({ 
  formData, 
  handleInputChange, 
  handleSelectChange, 
  handleCheckboxChange 
}: GoalsStepProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label>Primary Wellness Goals</Label>
        <div className="space-y-2 mt-2">
          {[
            "weight-loss", "weight-gain", "muscle-building", "energy-improvement", 
            "sleep-quality", "stress-reduction", "general-health", "athletic-performance"
          ].map((goal) => (
            <div key={goal} className="flex items-center space-x-2">
              <Checkbox
                id={`primary-${goal}`}
                checked={(formData.primaryGoals as string[]).includes(goal)}
                onCheckedChange={() => handleCheckboxChange("primaryGoals", goal)}
              />
              <Label htmlFor={`primary-${goal}`}>
                {goal.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
              </Label>
            </div>
          ))}
        </div>
      </div>

      <div>
        <Label htmlFor="timeframe">Goal Timeframe</Label>
        <Select 
          onValueChange={(value) => handleSelectChange("timeframe", value)}
          value={formData.timeframe}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select your goal timeframe" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="1-month">1 month</SelectItem>
            <SelectItem value="3-months">3 months</SelectItem>
            <SelectItem value="6-months">6 months</SelectItem>
            <SelectItem value="1-year">1 year</SelectItem>
            <SelectItem value="ongoing">Ongoing improvement</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor="additionalNotes">Additional Notes</Label>
        <Textarea
          id="additionalNotes"
          name="additionalNotes"
          value={formData.additionalNotes}
          onChange={handleInputChange}
          placeholder="Anything else you'd like us to know about your wellness goals?"
          className="resize-none h-32"
        />
      </div>
    </div>
  );
}
